<template>
  <div class="studentAchievement">
    <header v-if="teamInfo">
      <h3>松鼠杯</h3>
      <p>
        {{ currentDateLabel }}
        <img
          @click="handleDateSelection"
          class="calendar"
          src="../../../src/assets/images/winterGame/calendarGrayIcon.png"
          alt="calendar"
        />
        <!-- <svg
          @click="handleDateSelection"
          t="1681977184751"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="12697"
          width="32"
          height="32"
        >
          <path
            d="M864 192H704v-64h-64v64H384v-64h-64v64H160c-17.6 0-32 14.4-32 32v640c0 17.6 14.4 32 32 32h704c17.6 0 32-14.4 32-32V224c0-17.6-14.4-32-32-32z m-32 640H192V384h640v448zM384 512H256v-64h128v64z m192 0H448v-64h128v64z m192 0H640v-64h128v64zM384 640H256v-64h128v64z m192 0H448v-64h128v64z m192 0H640v-64h128v64zM384 768H256v-64h128v64z m192 0H448v-64h128v64z"
            p-id="12698"
            fill="#68707D"
          ></path>
        </svg> -->
      </p>
    </header>
    <section>
      <div class="list" v-if="list.length > 0">
        <div class="item" v-for="(item, index) in list">
          <div class="title">
            <h3>{{ item.real_name }}</h3>
            {{ item.uname }}
          </div>
          <main>
            <aside>
              <dl>
                <dt>学科</dt>
                <dd>
                  {{ item.subject_text }}
                </dd>
              </dl>
            </aside>
            <section>
              <div>
                <dl>
                  <dt>已结算局数</dt>
                  <dd>{{ item.pk_settled_team_count | formatNumberFilter }}</dd>
                </dl>
                <dl>
                  <dt>奖杯数</dt>
                  <dd>{{ item.pk_settled_team_score | formatNumberFilter }}</dd>
                </dl>
                <dl>
                  <dt>未结算局数</dt>
                  <dd>
                    {{ item.pk_no_settled_team_count | formatNumberFilter }}
                  </dd>
                </dl>
              </div>
              <div v-if="item.isShowAll">
                <dl>
                  <dt>胜/负/平/空</dt>
                  <dd>
                    {{ item.settled_team_win_count | formatNumberFilter }}/{{
                      item.settled_team_fail_count | formatNumberFilter
                    }}/{{
                      item.settled_team_flat_count | formatNumberFilter
                    }}/{{ item.settled_team_empty_count | formatNumberFilter }}
                  </dd>
                </dl>
                <dl>
                  <dt>胜率</dt>
                  <dd>{{ Math.round(item.pk_rate / 100) }}%</dd>
                </dl>
                <dl>
                  <dt>局均奖杯数</dt>
                  <dd>{{ item.average_score | formatNumberFilter }}</dd>
                </dl>
              </div>
            </section>
          </main>
          <div class="arrow" @click="showInfo(index)">
            <arrow :rotateDeg="item.rotateDeg" />
          </div>
        </div>
      </div>
      <div style="min-height: 80vh" class="emptyData" v-else>
        <emptyData />
      </div>
    </section>
    <div class="calendar">
      <van-calendar
        :default-date="maxDate"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="isCalendarShow"
        @confirm="onConfirm"
      />
    </div>
  </div>
</template>

<script>
import arrow from "./components/arrow.vue";
import emptyData from "./components/emptyData.vue";
import { memberScore, getTeamScheduleDates } from "../../api/winterGame";
import { Toast } from "vant";
import {
  format,
  formatDate,
  formatDateStr,
  formatMonthDate,
} from "@/util/util";
export default {
  components: {
    arrow,
    emptyData,
  },
  data() {
    return {
      list: [],
      rotateDeg: 135,
      isShowAll: false,
      currentDate: format(new Date()) + " 00:00:00",
      currentDateLabel: "",
      selectedTime: "",
      dateTime: "",
      currentCampusId: 0,
      currentUserId: 0,
      // scheduleId: "",
      // seasonId: "",
      isCalendarShow: false, // 是否显示日历
      enableDateList: [], //启用的日期列表
      enableDateMap: null, //启用的日期列表key-value键值对
      // minDate: new Date(2022, 3, 1),
      minDate: new Date(),
      maxDate: new Date(),
      teamInfo: null,
    };
  },
  created() {
    document.title = this.$route.meta.title || "松鼠杯";
  },
  mounted() {
    this.initTeamInfo();
    this.currentDateLabel = formatMonthDate(new Date());
    this.setUserInfo();
  },
  methods: {
    getYesterday() {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return yesterday;
    },
    initTeamInfo() {
      let teamInfo = localStorage.getItem("teamInfo");
      this.teamInfo = JSON.parse(teamInfo);
    },
    //这边主要处理不可选日期的禁选变灰
    formatter(day) {
      let now = new Date(day.date);
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let date = now.getDate(); //得到日期
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      const time = year + "-" + month + "-" + date; //（格式化"yyyy-MM-dd"）
      if (this.enableDateList.includes(time)) {
      } else {
        day.type = "disabled";
      }
      return day;
    },
    async getEnableDateList() {
      // let teamScheduleDatesData = JSON.parse(
      //   localStorage.getItem("teamScheduleDatesData")
      // );
      // if (teamScheduleDatesData) {
      //   this.enableDateList = teamScheduleDatesData;
      // }
      try {
        let res = await getTeamScheduleDates({ param: "" });
        if (res.code == 0 && res.data.length > 0) {
          let ymd = res.data[0].ymd.replace(/\-/g, "/");
          this.minDate = new Date(ymd);
          this.enableDateList = res.data.map((e) => e.ymd.split(" ")[0]);
          // 使用 reduce 方法将对象数组转换为 Map
          this.enableDateMap = res.data.reduce((map, obj) => {
            const { ymd, ...rest } = obj; // 提取 id 属性作为键，剩余属性作为值
            map.set(ymd.split(" ")[0], rest); // 将键值对添加到 Map 中
            return map;
          }, new Map());
          // console.log(this.enableDateMap);
          if (res.data.length > 0) {
            let length = res.data.length;
            let lastData = res.data[length - 1];
            this.memberScore(lastData.season_id, lastData.schedule_id);
          }
        }
      } catch (error) {
        console.error(error, "error getOpenIdUrl");
        Toast(error);
      }
    },
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.isCalendarShow = false;
      this.currentDate = date;
      let now = new Date(date);

      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let day = now.getDate(); //得到日期
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      const time = year + "-" + month + "-" + day;
      this.currentDateLabel = formatMonthDate(this.currentDate);
      let obj = this.enableDateMap.get(time);
      this.memberScore(obj["season_id"], obj["schedule_id"]);
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentUserId = userInfoId.agentUserId;
        this.currentCampusId = userInfoId.campusId;
        if (this.currentUserId) {
          // this.FunGetYesDate()
          this.getEnableDateList();
        }
      } else {
        Toast("找不到参赛信息");
      }
    },
    async memberScore(seasonId, scheduleId) {
      /**
       * lastScheduleTagId
       * :
       * "skd.23cj.tuandui"
       * lastSeasonTagId
       * :
       * "s.23.chunji"
       */

      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          scheduleId: scheduleId,
          seasonId: seasonId,
          date: formatDate(this.currentDate),
          currentCampusName: this.teamInfo.servicePointName,
          padTeamId: "",
          teamName: this.teamInfo.teamName,
        },
      };

      let res = await memberScore(params);

      if (res.code == 0) {
        res.data.forEach((item) => {
          item.isShow = false;
          item.rotateDeg = 135;
        });

        this.list = res.data;
      } else {
        Toast(res.message);
      }
    },
    showInfo(index) {
      let item = this.list[index];
      item.isShowAll = !item.isShowAll;
      if (item.isShowAll) {
        item.rotateDeg = -45;
      } else {
        item.rotateDeg = 135;
      }
      this.$set(this.list, index, item);
    },
    FunGetYesDate() {
      var myDate, myDateStr;
      // new Date() - 1000 * 60 * 60 * 24
      myDate = new Date();
      const yyyy = myDate.getFullYear(); //取四位年份
      const MM = myDate.getMonth() + 1; //取月份
      const dd = myDate.getDate(); //取日
      myDateStr = MM + "月" + dd + "日";
      console.log(myDateStr);
      this.selectedTime = myDateStr;
      this.dateTime =
        yyyy + "-" + (MM > 9 ? MM : "0" + MM) + "-" + (dd > 9 ? dd : "0" + dd);
      return myDateStr;
    },
    handleDateSelection() {
      this.isCalendarShow = true;
    },
  },
};
</script>
<style lang="less">
.calendar {
  width: 30px;
  height: 30px;
  margin-left: 10px !important;
  margin-bottom: 3px !important;
}
.van-calendar__selected-day {
  background: #58abf6;
}
.van-button--danger {
  background: #58abf6;
  border: 2px solid #58abf6;
}
</style>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

.studentAchievement {
  background: #f6f9fd;
  min-height: 100vh;
  header {
    height: 164px;
    background: #ffffff;
    margin-bottom: 16px;
    overflow: hidden;

    h3 {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #323232;
      line-height: 44px;
      text-align: center;
      margin-top: 32px;
    }

    p {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #68707d;
      line-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        margin-left: 10px;
        align-items: center;
        width: 42px;
      }
    }
  }
  > section {
    .item {
      width: 718px;
      margin: auto;
      position: relative;
      padding: 32px 54px 32px 32px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px;
      margin-bottom: 16px;
      .title {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 34px;
        margin-bottom: 32px;
        h3 {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #323232;
          line-height: 44px;
          margin-right: 16px;
        }
      }
      main {
        display: flex;
        dl {
          text-align: center;
          overflow: hidden;
          dt {
            height: auto;
            // height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #323232;
            // line-height: 40px;
            // white-space: nowrap;
          }
          dd {
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #68707d;
            line-height: 40px;
          }
        }
        aside {
          width: 100px;
          flex-shrink: 0;
          margin-right: 40px;
        }
        section {
          flex-grow: 1;
          & > div {
            display: flex;
            justify-content: space-between;
            &:first-child {
              margin-bottom: 48px;
            }
            dl {
              margin-right: 46px;
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
      .arrow {
        position: absolute;
        top: 90px;
        right: 16px;
      }
    }
    .emptyData {
      margin-top: 186px;
    }
  }
}
</style>
